<style scoped>
::v-deep .form-label {
    @apply font-semibold;
}
.success-msg {
    border-width: 2px;
    border-color: #70ad47;
    background-color: #e2f0d9;
    @apply text-center;
}
</style>

<template>
    <modal type="custom">
        <div class="text-lg font-bold">
            驗證手機號碼
        </div>
        <div v-if="$slots.default"><slot></slot></div>
        <div class="verfyPhoneNumberForm mt-8">
            <formFieldRow
                name="smsVerifyCode"
                :label="'驗證碼'"
                :errors="errors"
                class="field-smsVerifyCode"
            >
                <template #default="{hasError}">
                    <div class="flex items-center">
                        <input
                            class="form-input w-32"
                            :class="{
                                'border-red': hasError
                            }"
                            maxlength="4"
                            v-model="form.smsVerifyCode"
                        />
                        <div class="ml-4">
                            <div class="inline">沒有驗證碼？</div>
                            <loadingButton
                                @click="requestSendSms"
                                :status="sendSmsStatus"
                                @successShown="sendSmsStatus = undefined"
                                class="border-0 underline text-blue"
                            >
                                重新發送
                            </loadingButton>
                        </div>
                    </div>
                </template>
            </formFieldRow>
        </div>
        <div v-if="isSmsSent" class="success-msg">
            <div class="inline">
                已發出要求。如超過30分鐘仍未收到，請
            </div>
            <loadingButton
                @click="requestSendSms"
                :status="sendSmsStatus"
                class="border-0 underline text-blue px-1"
            >
                重新發送
            </loadingButton>
        </div>
        <errorBox :message="errors.server" />
        <div class="flex justify-end mt-4">
            <loadingButton
                class="btn btn-primary px-8"
                :status="saveStatus"
                @click="save"
            >
                確認驗證碼
            </loadingButton>
        </div>
    </modal>
</template>

<script>
import modal from './modal.vue';
import formFieldRow from './formFieldRow.vue';
import errorBox from './errorBox.vue';
import loadingButton from './loadingButton.vue';
import { instance } from '../utils/ajax';
import { validate } from '../utils/validationUtil';

async function requestSendSms() {
    try {
        let result = await instance.post(
            '/api/accountInfo/requestConfirmPhoneNumber'
        );
        return result.data;
    } catch (e) {
        /*eslint-disable no-console*/
        console.error('error request send sms');
        return { success: false, all: 'error.connect' };
    }
}

async function confirmPhoneNumber(form) {
    try {
        let result = await instance.post(
            '/api/accountInfo/confirmPhoneNumber',
            form
        );
        return result.data;
    } catch (e) {
        /*eslint-disable no-console*/
        console.error('error confirm phone number');
        return { success: false, all: 'error.connect' };
    }
}

export default {
    components: { modal, formFieldRow, errorBox, loadingButton },
    data() {
        return {
            form: {
                smsVerifyCode: undefined
            },
            errors: {},
            saveStatus: undefined,
            sendSmsStatus: undefined,
            isSmsSent: false
        };
    },
    mounted() {
        this.requestSendSms();
    },
    methods: {
        async requestSendSms() {
            this.sendSmsStatus = 'loading';
            const result = await requestSendSms();
            if (result.success) {
                this.isSmsSent = true;
                this.sendSmsStatus = 'success';
            } else {
                this.sendSmsStatus = undefined;
            }
        },
        async save() {
            this.errors = {};
            const v = validate(this.errors, this.form, {
                smsVerifyCode: { required: true }
            });
            if (v.hasError) {
                this.errors = v.errors;
                return;
            }
            this.saveStatus = 'loading';
            const result = await confirmPhoneNumber(this.form);
            if (result.success) {
                this.saveStatus = 'success';
                const user = result.data.user;
                this.$store.commit('setUser', user);
            } else {
                this.saveStatus = undefined;
                this.errors = result.data.errors;
            }
        }
    }
};
</script>
